import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { APPRoutes } from "../../Utils/Route";
import { SERVICE_UNAVAILABLE_EVENT } from "../../Utils/serviceStatus";

// Sends the user to the 503 page when the API reports it is unavailable (see
// Utils/serviceStatus.js). Renders nothing; must sit inside the Router.
const ServiceUnavailableWatcher = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const locationRef = useRef(location);
    locationRef.current = location;

    useEffect(() => {
        const handleUnavailable = () => {
            const { pathname, search } = locationRef.current;
            if (pathname === APPRoutes.SERVICE_UNAVAILABLE) return;
            navigate(APPRoutes.SERVICE_UNAVAILABLE, { replace: true, state: { from: pathname + search } });
        };

        window.addEventListener(SERVICE_UNAVAILABLE_EVENT, handleUnavailable);
        return () => window.removeEventListener(SERVICE_UNAVAILABLE_EVENT, handleUnavailable);
    }, [navigate]);

    return null;
};

export default ServiceUnavailableWatcher;
